import logo from "@assets/imgs/logo.png";
import { Organization, WithContext } from "schema-dts";

export const halalShopOrganizationLdConfig: WithContext<Organization> = {
  "@context": "https://schema.org" as const,
  "@type": "Organization" as const,
  name: "Halal Shop",
  telephone: "+7-717-268-8625",
  email: "info@halalguide.me",
  address: {
    "@type": "PostalAddress",
    addressCountry: "Россия",
    addressRegion: "Республика Татарстан",
    addressLocality: "Казань",
    streetAddress: "ул. Роторная, 1г",
  },
  logo: logo.src,
};
